
/*eslint-disable*/
import React from "react";
import { Link } from 'react-router-dom';
import { config } from "_constants";

// reactstrap components
import { NavItem, NavLink, Nav, Container, Row, Col } from "reactstrap";
class AuthFooter extends React.Component {
  render() {
    const isDarkMode = this.props.darkMode ? true : false 
    return (
      <>
        <footer className={isDarkMode ? "py-5 bg-darkMode" : "py-5 "} id="footer-main">
          <Container>
            <Row className="align-items-center justify-content-xl-between">
              <Col xl="6">
                <div className={isDarkMode ? "copyright text-center text-xl-left surtitle-light-gray" : "copyright text-center text-xl-left text-muted"}> 
                © {new Date().getFullYear()}{" "}
                  <Link
                      to={ {pathname: ``}}
                      className={isDarkMode ? "livenyte-title text-white" : "livenyte-title"}
                      style={{marginLeft: ".125rem"}}
                      >    LiveNyte
                    </Link>
                </div>
              </Col>
              <Col xl="6">
                <Nav className="nav-footer justify-content-center justify-content-xl-end">
                <NavItem>
                    <Link
                      to={ {pathname: ``}}
                      className={isDarkMode ? "nav-link surtitle-light-gray" : "nav-link"}

                      >
                      Home
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link
                      to={ {pathname: `/auth/creatorLanding`}}
                      className={isDarkMode ? "nav-link surtitle-light-gray" : "nav-link"}

                      >
                      Talent & Creators
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link
                      className={isDarkMode ? "nav-link surtitle-light-gray" : "nav-link"}
                      to={ {pathname: `/auth/fanLanding`}}
                    >
                      Fans
                    </Link>
                  </NavItem>
                  <NavItem>
                    <Link
                      className={isDarkMode ? "nav-link surtitle-light-gray" : "nav-link"}
                      to={ {pathname: `/auth/businessLanding`}}
                      >
                      Businesses
                    </Link>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={isDarkMode ? "nav-link surtitle-light-gray" : "nav-link"}
                      href={config.commonUrl + config.privacyLocalPath}
                      target="_blank"
                    >
                      Privacy
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      href={config.commonUrl + config.termsLocalPath}
                      target="_blank"
                      className={isDarkMode ? "nav-link surtitle-light-gray" : "nav-link"}

                    >
                      Terms
                    </NavLink>
                  </NavItem>
                </Nav>
              </Col>
            </Row>
          </Container>
        </footer>
      </>
    );
  }
}

export default AuthFooter;
